// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { routeTo } from 'redux-router-kit';

import * as Account from 'app/entities/Account';
import * as Zap from 'app/entities/Zap';
import ErrorBlockOrComponent from 'app/common/components/ErrorBlockOrComponent';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import ZapMoverAccountChoosers from 'app/zap-mover/components/ZapMoverAccountChoosers';
import hocify from 'app/common/components/hocify';
import { buildFromToLink } from 'app/zap-mover/Selectors';

import type { Dispatch } from 'app/common/types';

const accountToProps = accountEntity => ({
  id: Account.selectors.id(accountEntity),
  name: Account.selectors.name(accountEntity),
  planName: Account.selectors.prettyPlanName(accountEntity),
});

const mapStateToProps = (state, { fromAccountId, toAccountId }) => {
  const filterFrom = _.partial(Account.selectors.hasId, fromAccountId);
  const filterTo = _.partial(Account.selectors.hasId, toAccountId);
  const fromAccounts = Account.selectors.all
    // Select all non-to accounts
    .filterBy(_.negate(filterTo), state)
    // Only show accounts that have moveable zaps in them
    .filter(accountEntity =>
      Zap.selectors.all.canMoveZapsFromAccount(
        Account.selectors.id(accountEntity),
        state
      )
    )
    .map(accountToProps);
  const toAccounts = Account.selectors.all
    // Select all non-from accounts
    .filterBy(_.negate(filterFrom), state)
    .map(accountToProps);
  const isLoadingAccount = Account.selectors.all.isInitialLoad(state);
  return {
    errorMessage:
      !isLoadingAccount && Account.selectors.all.entities(state).length < 2
        ? `You need to belong to at least two accounts in order to move
      Zaps between them, but you only belong to one account.`
        : null,
    fromAccounts,
    isLoading: isLoadingAccount || !Zap.selectors.all.usageByAccount(state),
    fromId: fromAccountId,
    toId: toAccountId,
    toAccounts,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onChooseAccount(fromAccountId, toAccountId) {
      dispatch(routeTo(buildFromToLink(fromAccountId, toAccountId)));
    },
    onFlipAccounts(fromAccountId, toAccountId) {
      dispatch(routeTo(buildFromToLink(toAccountId, fromAccountId)));
    },
    onLoad() {
      dispatch(Account.actions.loadCollection());
      dispatch(Zap.actions.loadUsage());
    },
  };
};

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  hocify(ErrorBlockOrComponent),
  hocify(LoadingBlockOrComponent)
)(ZapMoverAccountChoosers);
